<template>
    <div class="columns is-vcentered">
        <div :class="{'column':true, 'is-hidden-mobile':!account.game1}">
        
            <char-card v-if="loaded && account.game1" 
                :name="account.game1.name"
                :pjClass="account.game1.class_field"
                :grandreset="account.game1.grandresets"
                :reset="account.game1.resets"
                :level="account.game1.clevel"
                :pk="account.game1.pkcount" 
                :str="account.game1.strength"
                :agi="account.game1.dexterity"
                :vit="account.game1.vitality"
                :ene="account.game1.energy"
                :zen="account.game1.money"
                :vip="account.game1.isvip"
                @addStat="toAddStat"
                @setReset="toReset" />
            <fa icon="user-slash" class="has-text-white fa-2x" v-else-if="loaded" />
            <fa v-else icon="circle-notch" class="fa-4x has-text-white" spin />
        
        </div>
        <div :class="{'column':true, 'is-hidden-mobile':!account.game2}">
        
            <char-card v-if="loaded && account.game2" 
                :name="account.game2.name"
                :pjClass="account.game2.class_field"
                :grandreset="account.game2.grandresets"
                :reset="account.game2.resets"
                :level="account.game2.clevel"
                :pk="account.game2.pkcount" 
                :str="account.game2.strength"
                :agi="account.game2.dexterity"
                :vit="account.game2.vitality"
                :ene="account.game2.energy"
                :zen="account.game2.money"
                :vip="account.game2.isvip"
                @addStat="toAddStat"
                @setReset="toReset" />
            <fa icon="user-slash" class="has-text-white fa-2x" v-else-if="loaded" />
            <fa v-else icon="circle-notch" class="fa-4x has-text-white" spin />
        
        </div>
        <div :class="{'column':true, 'is-hidden-mobile':!account.game3}">
        
            <char-card v-if="loaded && account.game3" 
                :name="account.game3.name"
                :pjClass="account.game3.class_field"
                :grandreset="account.game3.grandresets"
                :reset="account.game3.resets"
                :level="account.game3.clevel"
                :pk="account.game3.pkcount" 
                :str="account.game3.strength"
                :agi="account.game3.dexterity"
                :vit="account.game3.vitality"
                :ene="account.game3.energy"
                :zen="account.game3.money"
                :vip="account.game3.isvip"
                @addStat="toAddStat"
                @setReset="toReset" />
            <fa icon="user-slash" class="has-text-white fa-2x" v-else-if="loaded" />
            <fa v-else icon="circle-notch" class="fa-4x has-text-white" spin />
        
        </div>
        <div :class="{'column':true, 'is-hidden-mobile':!account.game4}">
        
            <char-card v-if="loaded && account.game4" 
                :name="account.game4.name"
                :pjClass="account.game4.class_field"
                :grandreset="account.game4.grandresets"
                :reset="account.game4.resets"
                :level="account.game4.clevel"
                :pk="account.game4.pkcount" 
                :str="account.game4.strength"
                :agi="account.game4.dexterity"
                :vit="account.game4.vitality"
                :ene="account.game4.energy"
                :zen="account.game4.money"
                :vip="account.game4.isvip"
                @addStat="toAddStat"
                @setReset="toReset" />
            <fa icon="user-slash" class="has-text-white fa-2x" v-else-if="loaded" />
            <fa v-else icon="circle-notch" class="fa-4x has-text-white" spin />
        
        </div>
        <div :class="{'column':true, 'is-hidden-mobile':!account.game5}">
        
            <char-card v-if="loaded && account.game5" 
                :name="account.game5.name"
                :pjClass="account.game5.class_field"
                :grandreset="account.game5.grandresets"
                :reset="account.game5.resets"
                :level="account.game5.clevel"
                :pk="account.game5.pkcount" 
                :str="account.game5.strength"
                :agi="account.game5.dexterity"
                :vit="account.game5.vitality"
                :ene="account.game5.energy"
                :zen="account.game5.money"
                :vip="account.game5.isvip"
                @addStat="toAddStat"
                @setReset="toReset" />
            <fa icon="user-slash" class="has-text-white fa-2x" v-else-if="loaded" />
            <fa v-else icon="circle-notch" class="fa-4x has-text-white" spin />
        
        </div>
    </div>
        <!-- <fa icon="user-slash" /> -->
</template>

<script>
import CharCard from '@/components/player/characterCard.vue'
// import UserService from '@/services/user.service.js';

export default {
    name:'DashboardCharacterPage',
    props: ['api','user'],
    components: {
        CharCard
    },
    data:()=>({
      loaded: false,
      account: {},
      charSelected: ''
    }),
    computed: {
        endpoint() {
            return this.$store.getters.GetEndpoints.dashboard.player.characters
        }
    },
    async created() {
        this.$store.commit('changeDashboardPage', 1)
        let data = this.$store.getters.GetJson('dashboard-characters')
        // let {data} = await UserService.getCharacters(this.user.username)
        this.account = data
        this.loaded = true
    },
    methods: {
        async toReset(char){
            await this.setCharacterPage(char, 12)
            // this.$router.push(`/cuenta/personajes/reset`)
        },
        async toAddStat(char) { 
            await this.setCharacterPage(char, 11)
            // this.$router.push(`/cuenta/personajes/puntos`)
        },
        setCharacterPage(char, page) {
            var tempArray = this.makeCharacterArray(),
                charLeft = [],
                charRight = [],
                tempCond = false
            for (var temp in tempArray) {
                if(tempArray[temp] == char) {
                    tempCond=true
                    continue
                }
                tempCond ? charRight.push(tempArray[temp]):charLeft.push(tempArray[temp])
            }
            this.$store.dispatch('setDashboardData', {
                character:char, 
                page:page,
                direction: {left:charLeft, right:charRight}
            })
        },
        makeCharacterArray() {
            const charArray = []
            if(this.account.game1) charArray.push(this.account.game1.name)
            if(this.account.game2) charArray.push(this.account.game2.name)
            if(this.account.game3) charArray.push(this.account.game3.name)
            if(this.account.game4) charArray.push(this.account.game4.name)
            if(this.account.game5) charArray.push(this.account.game5.name)
            return charArray
        }
    }
}
</script>

<style>

</style>